import React from "react";
import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { CcTooltip } from "../../design-system/carecentre";

const AI_CREDITS_PATH = "/d/company/settings/ai-credits";

const useStyles = makeStyles(() => ({
  chip: {
    flexShrink: 0,
    height: 24,
    background: "#fef3e6",
    color: "#b45309",
    border: "1px solid #f3d5a8",
    fontSize: 11,
    fontWeight: 700,
    cursor: "pointer",
    "& .MuiChip-icon": {
      color: "#b45309",
      marginLeft: 4,
      marginRight: -4,
      fontSize: 14,
    },
    "& .MuiChip-label": {
      padding: "0 8px",
    },
    "&:hover, &:focus": {
      background: "#fde8c8",
    },
  },
}));

const resolveLocation = (activeLocation, userLocations, user) => {
  const id = activeLocation?.id;
  if (!id) return activeLocation;
  return (
    (userLocations || []).find((item) => item.id === id) ||
    (user?.location || []).find((item) => item.id === id) ||
    activeLocation
  );
};

const LowCreditAlert = () => {
  const classes = useStyles();
  const history = useHistory();
  const user = useSelector((state) => state.AuthReducer.user);
  const { activeLocation, userLocations } = useSelector(
    (state) => state.SlickCareProfilesReducer,
  );

  const location = resolveLocation(activeLocation, userLocations, user);
  const carePlanningLow = Boolean(location?.care_planning_low_credit_alert);
  const generalLow = Boolean(location?.general_low_credit_alert);

  if (!carePlanningLow && !generalLow) {
    return null;
  }

  const lowWallets = [
    carePlanningLow ? "Care Planning" : null,
    generalLow ? "General AI" : null,
  ].filter(Boolean);
  const tooltip =
    lowWallets.length === 2
      ? "Care Planning and General AI credits are running low. Top up to keep AI available."
      : `${lowWallets[0]} credits are running low. Top up to keep AI available.`;

  return (
    <CcTooltip title={tooltip}>
      <Chip
        size="small"
        icon={<InfoOutlinedIcon />}
        label="Low credits"
        className={classes.chip}
        onClick={() => history.push(AI_CREDITS_PATH)}
      />
    </CcTooltip>
  );
};

export default LowCreditAlert;
